const audiences = [
  { icon: 'ri-user-add-line', title: 'Новые руководители', desc: 'Переход от роли специалиста к роли руководителя: постановка задач, делегирование, контроль и обратная связь.' },
  { icon: 'ri-award-line', title: 'Опытные руководители', desc: 'Систематизация управленческих подходов и развитие новых компетенций для более сложных задач.' },
  { icon: 'ri-building-2-line', title: 'Руководители среднего звена', desc: 'Повышение самостоятельности и эффективности управления подразделением.' },
  { icon: 'ri-team-line', title: 'Управленческие команды', desc: 'Формирование единого языка и стандартов управления внутри компании.' },
  { icon: 'ri-user-star-line', title: 'Кадровый резерв', desc: 'Подготовка перспективных сотрудников к будущим управленческим ролям.' },
  { icon: 'ri-bar-chart-2-line', title: 'Компании в период роста', desc: 'Развитие руководителей одновременно с масштабированием бизнеса и структуры.' },
];

export default function SuitableFor() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Кому особенно нужна программа развития
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Развитие управленческих компетенций решает задачи разных уровней — от новых руководителей до управленческих команд
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {audiences.map((a) => (
            <div key={a.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${a.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{a.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{a.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}